<template>
    <div class="modal fade" id="CargarProspectosModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="CargarProspectosModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="CargarProspectosModalLabel">Cargar Prospectos</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="form-group col-3">
                        <label for="prospectos_programa">Programa</label>
                        <select class="form-control" id="prospectos_programa" v-model="selectedProgramaId" @change="selectPrograma()">
                            <option selected disabled value="">Selecciona Programa...</option>
                            <option v-for="programa in programas" :key="programa.id" :value="programa.id">{{ programa.text }}</option>
                        </select>
                    </div>

                    <div class="form-group col-3">
                        <label for="prospectos_oferta">Oferta Academica</label>
                        <select class="form-control" id="prospectos_oferta" v-model="selectedOfertaId">
                            <option disabled selected value="">Selecciona Oferta Academica...</option>
                            <option v-for="oferta in ofertasAdademicas" :key="oferta.id" :value="oferta.id">{{ oferta.text }}</option>
                        </select>
                    </div>

                    <div class="form-group col-3">
                        <div class="form-group">
                            <label for="prospectos_nombre">Nombre</label>
                            <input type="email" class="form-control" id="prospectos_nombre" v-model="nombre">
                        </div>
                    </div>

                    <div class="form-group col-3 d-flex align-items-end">
                        <button v-if="!loading" class="btn btn-primary mb-3" @click="search()">Buscar</button>

                        <button v-if="loading" class="btn btn-primary mb-3" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Buscando...
                        </button>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" style="background-color: rgb(231, 235, 255);">
                        <div class="d-flex justify-content-between">
                            <div>
                                <i class="fas fa-hand-pointer mr-1"></i>
                                Selección de alumnos
                                </div>
                            <div style="color: #17a2b8" v-if="grupoToSave && grupoToSave.flexible">
                                <i class="fas fa-cube mr-1"></i>
                                <span>Flexible</span>
                            </div>
                            <div style="color: #808080" v-else>
                                <i class="fas fa-cube mr-1"></i>
                                <span>Flexible</span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <AlumnosEditList :alumnosOrigen="alumnosFiltrados" :alumnosDestino="alumnosEnGrupo" @alumnosDestinoChange="alumnosDestinoChange" />
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>

                <button type="button" class="btn btn-primary" v-if="!saving" @click="save">Guardar</button>

                <button v-if="saving" class="btn btn-primary" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                </button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import AlumnosEditList from './AlumnosEditList.vue';

export default {
    name: 'CargarProspectos',
    inject: ['programas$', 'selectedCicloChange$', 'selectedInstitucionChange$', 'alumnos$', 'selectedGrupoChange$', 'alumnosRefresh$'],
    data() {
        return {
            loading: false,
            saving: false,
            selectedProgramaId: '',
            selectedOfertaId: '',
            institucionId: '',
            ofertasAdademicas: [],
            alumnosFiltrados: [],
            alumnosEnGrupo: [],
            alumnosSave: null,
            alumnosDelete: null,
            grupoToSave: {},
            cicloToSave: {},
            nombre: ''
        }
    },
    mounted() {
        this.alumnos$.subscribe(alumnos => this.alumnosEnGrupo = alumnos);
        this.selectedGrupoChange$.subscribe(grupo => this.grupoToSave = grupo);
        this.selectedCicloChange$.subscribe(ciclo => this.cicloToSave = ciclo);
        this.selectedInstitucionChange$.subscribe(institucionId => this.institucionId = institucionId);

        $('#CargarProspectosModal').on('show.bs.modal', () => {
            this.alumnosFiltrados = [];
        });

        $('#CargarProspectosModal').on('hide.bs.modal', () => {
            this.loading = false;
            this.saving = false;
        });
    },
    methods: {
        async save() {
            try {
                this.saving = true;

                await axios.post(`/grupos-administrativos/guardarEstudiantes/${this.grupoToSave.id}/ciclo/${this.cicloToSave.id}`, {
                  alumnosDelete: Array.from(this.alumnosDelete).map(alumno => alumno.id),
                  alumnosSave: Array.from(this.alumnosSave).map(alumno => alumno.id)
                });

                this.saving = false;
                this.alumnosSave.clear();
                this.alumnosDelete.clear();
                this.refreshAlumnos();
                $('#CargarProspectosModal').modal('hide');
            } catch (error) {
                this.saving = false;
                toastr["error"](error, 'Error');
            }
        },
        refreshAlumnos() {
            this.alumnosRefresh$.next();
        },
        async selectPrograma() {
            this.ofertasAdademicas = await axios.get(`/ofertas/programa/${this.selectedProgramaId}/${this.cicloToSave.id}`).then(resp => resp.data);
            this.selectedOfertaId = '';
        },
        async search() {
            this.loading = true;
            this.alumnosFiltrados = await axios.get(`/grupos-administrativos/filtrarProspectos?&oferta_academica_id=${this.selectedOfertaId}&nombre=${this.nombre}`).then(resp => resp.data);
            this.loading = false;
        },
        alumnosDestinoChange(alumnos) {
          this.alumnosSave = alumnos.alumnosSave;
          this.alumnosDelete = alumnos.alumnosDelete;
        }
    },
    subscriptions () {
        return {
            programas: this.programas$
        }
    },
    components: {
        AlumnosEditList
    }
}
</script>

<style>

</style>
